"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TargetRunnerPicker", {
    enumerable: true,
    get: function() {
        return TargetRunnerPicker;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _targetgraph = require("@lage-run/target-graph");
const _url = require("url");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class TargetRunnerPicker {
    async pick(target) {
        if (target.id === (0, _targetgraph.getStartTargetId)()) {
            return new (await import("./NoOpRunner.js")).NoOpRunner();
        }
        if (!target.type) {
            target.type = "npmScript";
        }
        if (this.options[target.type]) {
            const config = this.options[target.type];
            const { script, options } = config;
            let importScript = script;
            if (!importScript.startsWith("file://")) {
                importScript = (0, _url.pathToFileURL)(importScript).toString();
            }
            const runnerModule = await import(importScript);
            const base = _path.default.basename(script);
            const runnerName = base.replace(_path.default.extname(base), "");
            const runner = typeof runnerModule[runnerName] === "function" ? runnerModule[runnerName] : typeof runnerModule.default === "function" ? runnerModule.default : typeof runnerModule.default[runnerName] === "function" ? runnerModule.default[runnerName] : runnerModule;
            return new runner(options);
        }
        throw new Error(`No runner found for target ${target.id}`);
    }
    constructor(options){
        _define_property(this, "options", void 0);
        this.options = options;
    }
}
